import React, { useEffect } from 'react';
import revenue from "../../assets/images/download (1).png";
import { useTranslation } from "react-i18next";
import io from "socket.io-client";
import cart from "../../assets/images/msg1176172984-45846-removebg-preview.png";
import balance from "../../assets/images/Removal-828.png";
import { ProgressBar } from 'react-bootstrap';
import config from "../../config";
const TotalProfit = ({ profitData, btcCNVPrice ,totalProfit}) => {
    const { t } = useTranslation();
    const [recentProfit,setRecentProfit]=React.useState(0)
    const [percentage,setPercentage]=React.useState(0)
    useEffect(()=>{
        
    // const socket = io.connect(config.API_URL);
    //  socket.on("profit", function (data) {
    //     console.log("10000", data);
    //     // setRecentProfit(data)
        
    //  });
     if(profitData?.recentProfit){
        setRecentProfit(!isNaN(parseFloat (profitData?.recentProfit))? parseFloat (profitData?.recentProfit).toFixed(2):0)
     }
        if(profitData?.monthlyProfit){
            setPercentage(!isNaN (parseFloat( profitData?.monthlyProfit))? (parseFloat( profitData?.monthlyProfit)/parseFloat( profitData?.target))*100:0)
        }
        
    },[profitData])
    return (
        <div className="abv_box">
            {/* 1 */}
            <div className="box box1">
                <div><img src={cart} style={{ width: '70px' }} alt="logo" /></div>
                <div className=''>
                    {/* <p> {t("ORDER_COUNT")} </p> */}
                    <p> {t("JUST_SOLD_SHOPIFY")} (TX,USA)</p>
                    <div className='mt-1' style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                        <h5 className='text-success'>$ {!isNaN(recentProfit)? parseFloat (recentProfit).toFixed(2) : 0}</h5>   
                        <div style={{ flex: 1 }}>
                            <ProgressBar
                                now={(parseFloat( totalProfit)/parseFloat( profitData?.target))*100 ||0}
                                style={{
                                    backgroundColor: '#ddd',
                                    borderRadius: '20px',
                                    height: '15px',
                                }}
                                variant="custom"
                                className='custom_progress'
                            />
                        </div>
                    </div>

                </div>
            </div>
            {/* 2 */}
            <div className="box box3">
                <div><img src={cart} style={{ width: '70px' }} alt="logo" /></div>
                <div>
                    <p> {t("ORDER_COUNT")} </p>
                    <h5>{profitData?.profitCount || 0}</h5>
                </div>
            </div>
            {/* 3 */}
            <div className="box box-4">
                <div><img src={balance} style={{ width: '70px' }} alt="logo" /></div>
                <div>
                    <p>{t("TODAY'S_PROFIT")}</p>
                    <h5 className="text-success">${!isNaN((profitData?.todayProfit))? parseFloat(profitData?.todayProfit).toFixed(2):0 || 0}</h5>
                    <h6 className="text-success">{!isNaN(parseFloat(profitData?.todayProfit))? (parseFloat(profitData?.todayProfit) / btcCNVPrice).toFixed(8):0 || 0} BTC</h6>

                </div>
            </div>
            {/* 4 */}
            <div className="box box2">
                {/* <div><img src={balance} style={{ width: '70px' }} alt="logo" /></div> */}
                <div className='w-100'>
                    <div className='d-flex justify-content-between w-100'>
                        <div>
                            <p>{t("MONTHLY_PROFIT")}</p>
                            <h5 className="text-success mt-1">${!isNaN(parseFloat(profitData?.monthlyProfit))?  parseFloat(profitData?.monthlyProfit).toFixed(2):0 || 0}</h5>
                            <h6 className="text-success mt-1">{!isNaN(parseFloat(profitData?.monthlyProfit))? (parseFloat(profitData?.monthlyProfit) / btcCNVPrice).toFixed(8):0 || 0} BTC</h6>
                        </div>
                        <div className='box22'>
                            {/* <p>{t("MONTHLY_PROFIT")}</p> */}
                            {/* <h5 className="text-success">${parseFloat(profitData?.monthlyProfit).toFixed(2) || 0}</h5>
                            <h6 className="text-success">{(parseFloat(profitData?.monthlyProfit) / btcCNVPrice).toFixed(8) || 0} BTC</h6> */}
                            {/* <h5 className="mt-1">0,00030000 GOAL</h5> */}
                            <h5 className="mt-1">{t('GOAL')}</h5>
                            <h6 className="mt-1">$ { isNaN(profitData?.target) ? 0 : parseFloat( profitData?.target)}</h6>
                        </div>
                    </div>
                    <div className="mt-5">
                        <ProgressBar
                            now={percentage}
                            style={{
                                backgroundColor: '#ddd', // your dark background
                                borderRadius: '20px', // full rounded
                                height: '15px', // adjust thickness
                            }}
                            variant="custom"
                            className='custom_progress'
                        />
                    </div>
                </div>

            </div>

        </div>
    );
};

export default TotalProfit;